import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PrefixService} from '../../../../../services/frefix.service';

@Component({
  selector: 'app-edit-standard-number',
  templateUrl: './edit-standard-number.component.html',
  styleUrls: ['./edit-standard-number.component.css']
})
export class EditStandardNumberComponent implements OnInit {

  stnNumber: string;
  newNumber: string;

  constructor(public activeModal: NgbActiveModal,
              private prefixService: PrefixService) {
  }

  ngOnInit() {
  }

  setCurrentNumber(number) {
    this.stnNumber = number;
    this.newNumber = number;
  }

  editNumber() {
    this.prefixService.customStndNumber = this.prefixService.getSelectedPrefix().name + this.newNumber;
    this.stnNumber = this.newNumber;
    this.activeModal.close('Close click');
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard/modal/edit-standard-number/edit-standard-number.component.ts